export default {
  displayName: {
    label: 'Názov',
    tooltip: 'Zobrazovaný názov kanála notifikácií',
  },
  description: {
    label: 'Popis',
    tooltip: 'Popis kanála notifikácií',
  },
  senderEmail: {
    label: 'E-mail odosielateľa',
    tooltip: 'E-mailová adresa odosielateľa, ktorá sa má použiť',
  },
  serverHost: {
    label: 'Poštový server',
    tooltip: 'Hostiteľ SMTP servera',
  },
  serverPort: {
    label: 'Port SMTP',
    tooltip: 'Port SMTP servera',
  },
  useSsl: {
    label: 'Použiť SSL',
    tooltip: 'Či sa má použiť protokol SSL',
  },
  credential: {
    label: 'Poverenie',
    tooltip: 'Nastavte alebo vytvorte prihlasovacie údaje.',
    setCredential: 'Nastaviť prihlasovacie údaje',
    updatingcredential: 'Aktualizovať prihlasovacie údaje',
    credentialUpdated: 'Prihlasovacie údaje budú aktualizované po uložení.',
  },
  notificationChannel: 'Kanály notifikácií',
  email: 'E-mail',
};
